import React from 'react'
const CoverageTextDetails = ({coverageDetailsData}) => {
  return (
    <div className='info-container'>
            <div className='text-transform'>
                <span className='label'>Insurance Name - </span> {coverageDetailsData.resource.class[0].value}
            </div>
    </div>
  )
}

export default CoverageTextDetails